import { GoogleServicePath } from "utils/constants";

export const googleRequests = {
  getGoogleRoomsSelect: () => `${GoogleServicePath}selects/courses`,
};
